import type {SegmentationAxes} from "~/pages/supplier-360/types/Supplier360Types";

export type SegmentationAxisKey = keyof SegmentationAxes;

export type SegmentationAxis = {
    key: SegmentationAxisKey;
    label: string;
    /** Copy for the 1 and 5 ends of the scale, shown under the label as `low → high`. */
    low: string;
    high: string;
};

/**
 * The five Kraljic axes, in the order the design scores them. All five are rated on one screen
 * with a 1–5 slider (half steps allowed) — the design's `SegWizard` no longer asks them as
 * separate questions. Copy is taken verbatim from the design's `AXES`
 * (`docs/Mithra 3.0/sup-segmentation.js`); `key` is the API field name (docs §2.12).
 */
export const SEGMENT_AXES: SegmentationAxis[] = [
    {
        key: 'spend_value',
        label: 'Spend value',
        low: 'Immaterial',
        high: 'Top of category',
    },
    {
        key: 'supply_risk',
        label: 'Supply risk',
        low: 'No exposure',
        high: 'Severe exposure',
    },
    {
        key: 'switching_difficulty',
        label: 'Switching difficulty',
        low: 'Swap in days',
        high: 'Multi-year migration',
    },
    {
        key: 'substitutes',
        label: 'Substitutes',
        low: 'Many alternatives',
        high: 'Sole source',
    },
    {
        key: 'business_criticality',
        label: 'Business criticality',
        low: 'Nice to have',
        high: 'Line-stopping',
    },
];

/** The axis values a supplier starts on in the "Set segmentation" form — mid-scale, nothing implied. */
export const SEGMENT_AXES_DEFAULT: SegmentationAxes = {
    spend_value: 3,
    supply_risk: 3,
    switching_difficulty: 3,
    substitutes: 3,
    business_criticality: 3,
};
